import './style.scss'

export const Loader = ({zIndex = 2}) => {
    return (
        <div style={{zIndex}} className={'loader-wrapper'}>
            <h1>Formulaic</h1>
        </div>
    )
}
